import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import Layout from '@components/Layout';
import LinkTranslated from '@components/shared/LinkTranslated';

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default function Terms() {
  const SEO = {
    uid: 'terms',
    href: '/terms/',
    title: 'Terms & Conditions'
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.iubenda.com/iubenda.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (script && script.parentNode === document.body) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <Layout SEO={SEO}>
      <TermsWrap>
        <LinkTranslated
          to="https://www.iubenda.com/terms-and-conditions/80288176"
          className="iubenda-white iubenda-embed iub-body-embed"
          title="Terms and Conditions"
        >
          Terms and Conditions
        </LinkTranslated>
      </TermsWrap>
    </Layout>
  );
}

const TermsWrap = styled.div`
  width: 800px;
  max-width: 100%;
  padding: 0 20px;
  margin: 100px auto;
`;
